import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateAgreement=(statement,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_AGREEMENT_START
    })
    const options={
        url:`${api}/agreements`,
        method:'PUT',
        headers:{
            Authorization:`Bearer ${token}`
        },
        data:{
            statement
        }
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_AGREEMENT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_AGREEMENT_FAIL,
                payload:getMessage(error)
            }))
}